/** @format */

/// types
export enum FormItemType {
	Answer = "Answer",
	Checkboxes = "Checkboxes",
	LinearScale = "LinearScale",
	MultipleChoice = "MultipleChoice",
	Dropdown = "Dropdown",
	HTML = "HTML",
	Information = "Information",
}
